<script lang="ts" setup>
export type CareerBox = {
    id: number
    position: string
    location: string
    job_types: string[]
    url: string
}

export interface CareerBoxProps {
    data: CareerBox
    headingLevel: string
}

const props = defineProps<CareerBoxProps>()
</script>
<template>
  <article class="rounded bg-white box-shadow-1 p-4 px-md-6">
    <Heading
      level="h3"
      class="fs-normal mb-2"
    >
      <VNuxtLink
        class="fw-bolder text-black"
        :to="props.data.url"
        :label="props.data.url"
        target="_blank"
      >
        {{ props.data.position }}
      </VNuxtLink>
    </Heading>
    <div class="d-flex align-items-center flex-wrap gap-2 gap-lg-5">
      <CareerBoxLocation :definition="props.data.location" />
      <CareerBoxPosition :definition="props.data.job_types" />
    </div>
  </article>
</template>
